// Module
var code = "<div class=\"dms-tree-wrapper dms-outer-element\">\r\n    <div class=\"dms-grid-wrapper dms-tree #=data.GridName#\"></div>\r\n</div>\r\n";
// Exports
export default code;